export default __webpack_public_path__ + "static/media/ke.48e2f2cb.svg";